import { Controller } from '@hotwired/stimulus';

export default class BreadcrumbController extends Controller {
  static targets = ['breadcrumbElement', 'completion'];

  connect() {
    this.element.addEventListener(
      'signature:breadcrumb-update',
      this.handleBreadcrumbUpdate.bind(this)
    );
  }

  disconnect() {
    this.element.removeEventListener(
      'signature:breadcrumb-update',
      this.handleBreadcrumbUpdate.bind(this)
    );
  }

  handleBreadcrumbUpdate(event) {
    const { step, completionText } = event.detail;
    this.updateBreadcrumb(step, completionText);
  }

  updateBreadcrumb(step, completionText = null) {
    if (!this.hasBreadcrumbElementTarget) {
      return;
    }

    const breadcrumbElements = this.breadcrumbElementTargets;

    if (step === 4 && breadcrumbElements.length >= 4) {
      if (breadcrumbElements[2]) {
        breadcrumbElements[2].classList.remove('current');
        breadcrumbElements[2].classList.add('past');
      }
      if (breadcrumbElements[3]) {
        breadcrumbElements[3].classList.remove('next');
        breadcrumbElements[3].classList.add('current');
      }
    }

    if (completionText && this.hasCompletionTarget) {
      this.completionTarget.textContent = completionText;
    }
  }
}
